(() => {
    window.$ = jQuery;
    const SELECTOR_SLICK = '.hero-40__gallery.slick-enabled';
    const SETTINGS_SLICK = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">&nbsp</button>',
        nextArrow: '<button type="button" class="slick-next">&nbsp</button>',
        arrows: true,
        autoplay: false,
    };

    const initSlick = () => {
        const element = $(SELECTOR_SLICK);
        element.slick(SETTINGS_SLICK);
    };

    document.addEventListener('DOMContentLoaded', () => {
        initSlick();
    });
})()
